import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useScrollToId from 'hooks/useScrollToId'
import React from 'react'
import LuxPlusBenefitIcon from './LuxPlusBenefitIcon'
import { getBenefitCtaConfig } from 'luxPlus/lib/utils'

interface Props {
  benefit: App.OfferSubscriptionBenefitItem
  noCta?: boolean
}

function LuxPlusLandingPageBenefit(props: Props) {
  const { benefit, noCta } = props

  const {
    hasLoadedScrollElement,
    onScrollToId,
  } = useScrollToId(benefit.type, -12)

  const ctaConfig = !noCta ? getBenefitCtaConfig(benefit.type) : undefined

  return <Group direction="vertical" gap={12} verticalAlign="space-between" key={benefit.title}>
    <VerticalSpacer gap={12}>
      <LuxPlusBenefitIcon benefit={benefit} colour="neutral-one" size="L" />
      <BodyText
        variant="medium"
        weight="bold"
        colour="neutral-one"
      >
        {benefit.title}
      </BodyText>
    </VerticalSpacer>
    {!!ctaConfig && <>
      {ctaConfig.hasScrollElement && hasLoadedScrollElement && <TextLink size="small" onClick={onScrollToId}>Browse offers</TextLink>}
      {ctaConfig.path && <TextLink size="small" to={ctaConfig.path}>Learn more</TextLink>}
    </>}
  </Group>
}

export default LuxPlusLandingPageBenefit
